import { Signal, computed, inject } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'

import { patchState, signalStore, withMethods, withState } from '@ngrx/signals'

import { StaticAsset } from '@flowx/core-sdk'
import { FlxTheme2Service } from '@flowx/ui-theme'

export type StaticAssets = Record<string, string>

const initialState: { staticAssets: StaticAssets } = {
  staticAssets: {},
}

export const StaticAssetsStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    setStaticAssets: (staticAssets: StaticAsset[]): void => {
      const staticAssetsMap: Record<string, string> = {}
      staticAssets.forEach((asset) => {
        const key = (asset.appId || '') + asset.key
        staticAssetsMap[key] = asset.storagePath
      })
      patchState(store, { staticAssets: staticAssetsMap })
    },
    getStaticAssetByKey: (key: string): string | undefined => store.staticAssets()[key],
    getStaticAssetByKeySignal: (key: string): Signal<string | undefined> =>
      computed(() => store.staticAssets()[key]),
    clearStaticAssets: (): void => {
      patchState(store, { staticAssets: {} })
    },
  }))
)

export function getIconAssetSignal(
  component: any,
  iconName: string,
  themeService = inject(FlxTheme2Service),
  staticAssetsStore = inject(StaticAssetsStore)
): Signal<string | undefined> {
  const iconKeySignal = toSignal(themeService.getComponentIcons(component, iconName), {
    initialValue: undefined,
  })
  return computed(() => {
    const iconKey = iconKeySignal()
    return iconKey ? staticAssetsStore.getStaticAssetByKey(iconKey) : undefined
  })
}
